import curd from '../curd'

const BASE_PATH = '/configure/measure/instrument'

export default curd(BASE_PATH, {
  getInstanceById: (year, id) => ({
    url: `${BASE_PATH}/enumeration/app/list/${year}/${id}`,
    methods: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/MeasureInstrument.js